import React, { Component } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import styled from "styled-components";
import {
  NavItem,
  Navbar,
  Nav,
  Label,
  NavLink,
  Row,
  Col,
  Container,
} from "reactstrap";
import { getTaskCount, getSetup } from "./../../Constants/Services";
import { ISetup } from "./../../Constants/Interfaces";
import StoreContext from "./../../../Store/Context";
import {
  LOGO_SCHOOL,
  LOGOUT_ICON,
  MESSAGE_ICON,
  AGENDA_ICON,
  NOTAS_ICON,
  HORARIO_ICON,
  HOME_ICON,
  HOMEWORK_ICON,
} from "../../Constants/SrcImages";
import { push as Menu } from "react-burger-menu";
import "./../../../www/css/Menu.css";
import { GET_WEEK_START_END } from "./../../Constants/Util";
import moment from "moment";
const Logo = styled.img`
  height: 100px;
  width: 100px;
  margin: auto;
`;

var styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    left: "26px",
    top: "16px",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

interface ILayoutState {
  menuOpen: boolean;
  children: any;
  dataFormSetup: ISetup;
  count: string;
  count_total: string;
}

interface ILayoutProps {
  children: any;
}
class Layout extends Component<ILayoutProps, ILayoutState> {
  static contextType = StoreContext;
  constructor(props: ILayoutProps) {
    super(props);
    this.state = {
      menuOpen: false,
      children: props.children,
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      count: "0",
      count_total: "0",
    };
    this.fetchTaskCount = this.fetchTaskCount.bind(this);
  }

  handleStateChange(state: any) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  }

  updateTokens = () => {
    const test = this.context;
    test.quitToken();
  };

  async fetchTaskCount({ trimestre }) {
    const props = this.state;
    var dataStartTrimestre;
    var dataEndTrimestre;

    if (trimestre === "I") {
      dataStartTrimestre = props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    } else if (trimestre === "II") {
      dataStartTrimestre = props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    } else if (trimestre === "III") {
      dataStartTrimestre = props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }

    var daysMonth = GET_WEEK_START_END({
      startDate: dataStartTrimestre,
      endDate: dataEndTrimestre,
    });

    var position = 0;
    var position2 =0;
    daysMonth.map((data, i) => {
      if( moment(new Date()).isAfter(moment(data.dateStart).format("YYYY-MM-DD")) &&   moment(new Date()).isBefore(moment(data.dateEnd).add(1,'days').format("YYYY-MM-DD")))
      {
       position=i;
      }
      return null
    });

    var fechaFiltro;
    // if (
    //   moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(
    //     moment(daysMonth[position.toString()].dateStart).format(
    //       "YYYY-MM-DD HH:mm:ss"
    //     )
    //   )
    // ) {
    //   fechaFiltro = daysMonth[position.toString()].dateEnd;
    // } else {
    //   if (
    //     moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(
    //       moment(daysMonth[position.toString()].dateEnd)
    //         .subtract(2, "days")
    //         .add(14, "hours")
    //         .format("YYYY-MM-DD HH:mm:ss")
    //     )
    //   ) {
    //     var position = position + 1;
    //     fechaFiltro = moment(daysMonth[position.toString()].dateEnd).format(
    //       "YYYY-MM-DD"
    //     );
    //   }
    // }

      if (
        moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment(daysMonth[position.toString()].dateEnd)
        .subtract(2, "days").add(14, "hours").format("YYYY-MM-DD HH:mm:ss"))
      ){
        position2 = position +1;
        fechaFiltro = moment(daysMonth[position2.toString()].dateEnd).format("YYYY-MM-DD");
      }
      else{
        fechaFiltro = moment(daysMonth[position.toString()].dateEnd).format("YYYY-MM-DD");
      }

    const response = await getTaskCount({
      per_id: this.context.per_id,
      date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
      date_week_end: fechaFiltro,
    });

    this.setState({ count: response.count });
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
    });
    setTimeout(() => {
      this.fetchTaskCount({ trimestre: response.set_trimestre });
    }, 500);
  }

  componentDidMount() {
    this.fetchSetup();
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {window.screen.width < 576 && (
          <div className="d-block d-sm-none">
            {/* MOBILE */}
            <Menu
              id="menu-mb"
              styles={styles}
              width={180}
              isOpen={this.state.menuOpen}
              onStateChange={(state) => this.handleStateChange(state)}
            >
              <img className="logo-mobile" src={LOGO_SCHOOL} alt="" />
              <NavItem className="text-center w-100 mt-5 d-flex">
                <img src={HOME_ICON} alt="" />
                <NavLink
                  tag={RRNavLink}
                  to="/student/home"
                  onClick={() => this.closeMenu()}
                >
                  Inicio
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={AGENDA_ICON} alt="" />
                <NavLink
                  tag={RRNavLink}
                  to="/student/agenda"
                  onClick={() => this.closeMenu()}
                >
                  Agenda
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={NOTAS_ICON} alt="" />
                <NavLink
                  tag={RRNavLink}
                  to="/student/notes"
                  onClick={() => this.closeMenu()}
                >
                  Notas
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={MESSAGE_ICON} alt="" />
                <NavLink
                  tag={RRNavLink}
                  to="/student/messages"
                  onClick={() => this.closeMenu()}
                >
                  Mensajes
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={HORARIO_ICON} alt="" />
                <NavLink
                  tag={RRNavLink}
                  to="/student/schedule"
                  onClick={() => this.closeMenu()}
                >
                  Horario
                </NavLink>
              </NavItem>
              <NavItem
                className="text-center w-100 d-flex"
                onClick={() => this.updateTokens()}
              >
                <img src={LOGOUT_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/student/profile">
                  Salir
                </NavLink>
              </NavItem>

              <Label className="task-label">
                Tareas y revisiones Faltantes: {props.count}
              </Label>
              <img src={HOMEWORK_ICON} alt="" className="homework-icon" />
            </Menu>
            <Container className="font-size-14">
              <Row>
                <Col sm={12} className="container-mobile">
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}

        {window.screen.width > 576 && (
          <div className="d-none d-sm-block">
            <Container fluid={true} className="font-size-14">
              <Row>
                <Col sm={2}>
                  <Row>
                    <Navbar>
                      <Nav tabs>
                        <NavItem className="text-center w-100">
                          <Logo src={LOGO_SCHOOL} alt="" />
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink
                            tag={RRNavLink}
                            to="/student/home"
                            activeClassName="active"
                          >
                            Inicio
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink
                            tag={RRNavLink}
                            to="/student/agenda"
                            activeClassName="active"
                          >
                            Agenda
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink
                            tag={RRNavLink}
                            to="/student/notes"
                            activeClassName="active"
                          >
                            Notas
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink
                            tag={RRNavLink}
                            to="/student/messages"
                            activeClassName="active"
                          >
                            Mensajes
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink
                            tag={RRNavLink}
                            to="/student/schedule"
                            activeClassName="active"
                          >
                            Horario
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className="text-center w-100"
                          onClick={() => this.updateTokens()}
                        >
                          <NavLink tag={RRNavLink} to="/student/profile">
                            Salir
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Navbar>
                  </Row>
                  <Row>
                    <Col xs={2}></Col>
                    <Col xs={10} className="text-center">
                      <Label className="font-weight-bold">
                        Tareas y revisiones Faltantes: {props.count}
                      </Label>
                      <img
                        src={HOMEWORK_ICON}
                        alt=""
                        className="homework-icon"
                      />
                    </Col>
                  </Row>
                </Col>
                <Col className="mt-50px" sm={10}>
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default Layout;
